import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=63b893c9&scoped=true&"
import script from "./Discounts.vue?vue&type=script&lang=ts&"
export * from "./Discounts.vue?vue&type=script&lang=ts&"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=63b893c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b893c9",
  null
  
)

export default component.exports